var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisualTestingBot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 236,
    viewBox: "0 0 260 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.7767 96.4715C68.6398 126.207 89.8919 154.798 121.245 160.114C152.598 165.431 182.024 145.579 187.161 115.844C192.298 86.1081 171.046 57.5172 139.693 52.2008C108.34 46.8843 78.9123 66.5391 73.7767 96.4715Z",
    fill: "url(#paint0_linear_3579_3024)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.702 152.188C104.484 152.348 83.1003 131.253 82.9403 105.071C82.7803 78.8885 103.904 57.5338 130.122 57.3736C156.34 57.2134 177.723 78.3083 177.883 104.491C178.043 130.673 156.919 152.027 130.702 152.188Z",
    fill: "url(#paint1_linear_3579_3024)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.445 148.846C106.077 148.994 86.2019 129.387 86.0532 105.052C85.9045 80.7169 105.538 60.8685 129.907 60.7196C154.275 60.5707 174.15 80.1776 174.299 104.513C174.448 128.848 154.814 148.697 130.445 148.846Z",
    fill: "url(#paint2_linear_3579_3024)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M79.9085 79.2521C83.047 81.875 80.745 98.2217 76.932 124.972C75.5364 122.227 65.8536 100.19 79.9085 79.2521Z",
    fill: "url(#paint3_linear_3579_3024)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3178 76.7077C66.1647 70.9259 72.7201 82.8647 79.4317 80.212C79.5344 97.0244 77.9148 107.122 75.8428 121.786C68.5381 119.14 62.773 112.225 61.5959 109.384C60.4189 106.542 64.2661 104.287 66.3496 101.188C68.4332 98.0889 61.4463 80.5087 63.3178 76.7077Z",
    fill: "url(#paint4_linear_3579_3024)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.543 80.2254C177.436 82.8864 179.938 99.2038 184.078 125.906C185.44 123.143 194.852 100.99 180.543 80.2254Z",
    fill: "url(#paint5_linear_3579_3024)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.101 77.4838C194.183 71.7372 187.774 83.7553 181.031 81.1848C181.133 97.9972 182.876 108.074 185.127 122.712C192.399 119.977 198.079 112.992 199.222 110.136C200.364 107.28 196.489 105.073 194.368 101.999C192.247 98.9259 199.018 81.2616 197.101 77.4838Z",
    fill: "url(#paint6_linear_3579_3024)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8647 178.154C93.8592 177.73 94.1617 176.232 95.2527 176.232H170.268C170.401 176.232 170.533 176.259 170.656 176.311L194.646 186.412C195.652 186.835 195.349 188.333 194.258 188.333H119.243C119.109 188.333 118.977 188.307 118.855 188.255L94.8647 178.154Z",
    fill: "#6BB545"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.402 176.232H176.788C176.93 176.232 177.071 176.262 177.2 176.321L199.524 186.422C200.505 186.866 200.189 188.333 199.112 188.333H129.362C129.22 188.333 129.079 188.303 128.949 188.244L102.402 176.232Z",
    fill: "#A0D64E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4633 152.646C81.7224 149.511 74.3818 155.19 73.1134 160.848C71.3961 164.026 73.5115 170.008 82.8187 173.286C93.2875 176.973 129.212 184.544 129.025 177.705C128.701 165.821 103.639 156.565 91.4633 152.646Z",
    fill: "url(#paint7_linear_3579_3024)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.944 133.273C128.044 132.747 128.503 132.366 129.039 132.366H208.453C209.152 132.366 209.678 133.001 209.548 133.687L199.381 187.427C199.281 187.953 198.822 188.333 198.286 188.333H118.872C118.174 188.333 117.647 187.699 117.777 187.013L127.944 133.273Z",
    fill: "#6BB545"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.972 136.3C131.071 135.774 131.531 135.392 132.067 135.392H203.919C204.616 135.392 205.142 136.025 205.014 136.711L196.356 182.887C196.257 183.414 195.797 183.796 195.261 183.796H123.408C122.711 183.796 122.185 183.162 122.314 182.477L130.972 136.3Z",
    fill: "#A0D64E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3579_3024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.47 169.377L156.753 146.534C156.813 146.213 157.094 145.98 157.421 145.98H178.232C178.783 145.98 179.105 146.602 178.786 147.052L171.419 157.442C171.298 157.614 171.262 157.832 171.323 158.033L174.742 169.305C174.875 169.742 174.548 170.182 174.092 170.182H153.138C152.712 170.182 152.391 169.795 152.47 169.377Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3579_3024)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.484,
    y: 110.823,
    width: 7.60149,
    height: 7.60149,
    transform: "rotate(-90.0833 142.484 110.823)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.107,
    y: 103.646,
    width: 7.60149,
    height: 7.60149,
    transform: "rotate(-90.0833 148.107 103.646)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.773,
    y: 103.634,
    width: 7.60149,
    height: 7.60149,
    transform: "rotate(-90.0833 154.773 103.634)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.414,
    y: 110.801,
    width: 7.60149,
    height: 7.60149,
    transform: "rotate(-90.0833 160.414 110.801)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3579_3024)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.735,
    y: 111.351,
    width: 7.60149,
    height: 7.60149,
    transform: "rotate(-90.0833 105.735 111.351)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.358,
    y: 104.176,
    width: 7.60149,
    height: 7.60149,
    transform: "rotate(-90.0833 111.358 104.176)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.024,
    y: 104.161,
    width: 7.60149,
    height: 7.60149,
    transform: "rotate(-90.0833 118.024 104.161)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.665,
    y: 111.331,
    width: 7.60149,
    height: 7.60149,
    transform: "rotate(-90.0833 123.665 111.331)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3579_3024",
    x: 150.458,
    y: 145.98,
    width: 30.4541,
    height: 30.2021,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3579_3024"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.25098 0 0 0 0 0.454902 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3579_3024"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3579_3024"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.25098 0 0 0 0 0.454902 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3579_3024",
    result: "effect2_dropShadow_3579_3024"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3579_3024",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3579_3024",
    x: 138.473,
    y: 96.0212,
    width: 33.542,
    height: 22.8018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3579_3024"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3579_3024",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3579_3024",
    x: 101.724,
    y: 96.5481,
    width: 33.5425,
    height: 22.803,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3579_3024"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3579_3024",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3579_3024",
    x1: 180.881,
    y1: 41.6507,
    x2: 84.2468,
    y2: 161.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.5e-7,
    stopColor: "#E6FEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#E1F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7158,
    stopColor: "#D2DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3579_3024",
    x1: 97.1437,
    y1: 166.346,
    x2: 159.837,
    y2: 50.0236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0037BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0036C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3579_3024",
    x1: 148.511,
    y1: 70.8063,
    x2: 110.012,
    y2: 142.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0037BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0036C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3579_3024",
    x1: 95.4521,
    y1: 84.4403,
    x2: 45.3331,
    y2: 135.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0037BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#0036C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3579_3024",
    x1: 51.7067,
    y1: 83.0326,
    x2: 93.966,
    y2: 127.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0037BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#0036C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3579_3024",
    x1: 165.064,
    y1: 85.6031,
    x2: 215.804,
    y2: 136.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0037BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#0036C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3579_3024",
    x1: 208.788,
    y1: 83.6663,
    x2: 167.077,
    y2: 128.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0037BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#0036C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3579_3024",
    x1: 73.5415,
    y1: 160.074,
    x2: 130.208,
    y2: 172.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0137C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#296AEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualTestingBot);
export default __webpack_public_path__ + "static/media/visual-testing-bot.228677c439f7b3eab50334082e043f76.svg";
export { ForwardRef as ReactComponent };